import bodymovin from 'bodymovin';

export class Animator {

    constructor(element,delay,data,animate) {
        this.element = element;
        this.delay = delay;
        this.data = data;
        this.animate = animate;
        this.animations = this.element.map(function(n){
            return bodymovin.loadAnimation({
                container: n,
                renderer:'svg',
                loop:false,
                autoplay: false,
                animationData: data
            });
        });

        if(animate) {
            this.doOnAnimation();
        }

    }

    doOnAnimation() {
        this.doAnimation(this.animate, this.delay);
    }

    doAnimation(frames, delay = 0) {
        setTimeout(()=>{
            let i = 0;
            while(i < this.animations.length) {
                this.animations[i].playSegments(frames, true);
                i++;
            }
        }, delay);
    }

}


// WEBPACK FOOTER //
// ./assets/js/libraries/animation.js